module.exports = __webpack_public_path__ + "static/media/tag_black.5beb1b2b.svg";